import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const PreventionMetricsCard = ({ title, value, trend, icon: Icon, color }) => {
  const colorClasses = {
    red: 'bg-red-50 text-red-600 border-red-200',
    green: 'bg-green-50 text-green-600 border-green-200',
    blue: 'bg-blue-50 text-blue-600 border-blue-200',
    purple: 'bg-purple-50 text-purple-600 border-purple-200',
    orange: 'bg-orange-50 text-orange-600 border-orange-200'
  };

  const getTrendIcon = () => {
    if (trend === 'up') return <TrendingUp className="h-4 w-4 text-green-600" />;
    if (trend === 'down') return <TrendingDown className="h-4 w-4 text-red-600" />;
    return <Minus className="h-4 w-4 text-gray-400" />;
  };

  return (
    <div className={`border rounded-lg p-6 ${colorClasses?.[color] || 'bg-gray-50 text-gray-600 border-gray-200'}`}>
      <div className="flex items-center justify-between mb-4">
        <Icon className="h-8 w-8" />
        {getTrendIcon()}
      </div>
      <div className="text-sm font-medium opacity-80 mb-1">{title}</div>
      <div className="text-2xl font-bold">{value}</div>
    </div>
  );
};

export default PreventionMetricsCard;